import { isNonEmptyArray } from '@vista-digital/utilities';
import { loadAllFilms } from './load-all-films';
import { loadFilmsForSite } from './load-films-for-site';
export const loadFilms = async (siteIds) => {
    if (isNonEmptyArray(siteIds))
        await loadsFilmsForSites(siteIds);
    else
        return loadAllFilms();
};
const loadsFilmsForSites = async (siteIds) => {
    const promises = siteIds.map(siteId => loadFilmsForSite(siteId));
    await Promise.all(promises);
};
//# sourceMappingURL=load-films.js.map